module.exports = __webpack_public_path__ + "fonts/Sailec-Medium.3e166e92.eot";